import React from "react";
import './styles.less';
import PropTypes from 'prop-types';

const ApartmentOwnerMaintainance = ({item}) => {
    const text = item && item.Description ? `Out Of Order -${item.Description}` : "Out Of Order";
    return(
        <div className={"maintainance-wrapper"}>
            <b>{text}</b>
        </div>
    )
}

ApartmentOwnerMaintainance.propTypes = {
    item: PropTypes.object
}

export default ApartmentOwnerMaintainance;